module.exports = __webpack_public_path__ + "static/work10-021295967f52d15bb96a3ba46ac0d831.jpg";